<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-layout wrap justify-center px-2>
      <v-flex xs12>
        <ProductDetails
          v-bind:productData="productData"
          v-bind:productPhotos="productPhotos"
        />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import ProductDetails from "./productDetails";
export default {
  props: ["id"],
  components: {
    ProductDetails,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      productData: {},
      productPhotos: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "product/view",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.$route.params.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.productData = response.data.data;
          if (this.productData.updatedProducts) {
            let updated = this.productData.updatedProducts;
            if (!updated.photos || updated.photos.length === 0) {
               delete updated.photos;
            }
            delete updated.rating;
            delete updated.ratingcount;
            Object.assign(this.productData, updated);
          }
          this.productPhotos = this.productData.photos;
          this.loadContent = true;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
